(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.headerMedia = window.matchMedia('(max-width: 989px)');
      this.onHeaderResize = () => {
        if (this.usesMuvaziMobileHeader()) {
          this.header.classList.remove('shopify-section-header-hidden', 'animate');
        }
        this.setHeaderHeight();
      };
      this.headerMedia.addEventListener('change', this.onHeaderResize);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    usesMuvaziMobileHeader() {
      return this.dataset.muvaziMobileHeader === 'true' && this.headerMedia?.matches;
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerMedia?.removeEventListener('change', this.onHeaderResize);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // Mobile stays visible in both directions. CSS handles its sticky position;
      // the MUVAZI controller handles the logo and surface independently of page type.
      if (this.usesMuvaziMobileHeader()) {
        this.currentScrollTop = scrollTop;
        return;
      }
      // Desktop navigation and search remain available throughout the scroll.
      if (!this.headerMedia.matches) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        this.currentScrollTop = scrollTop;
        return;
      }
      // Keep the header visible while the search dialog is open. Focusing its
      // input can trigger a scroll event, which would otherwise hide it again.
      if (this.querySelector('details-modal details[open]')) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky || this.usesMuvaziMobileHeader()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky || this.usesMuvaziMobileHeader()) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky || this.usesMuvaziMobileHeader()) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.header.querySelectorAll('details-modal').forEach((modal) => {
        if (modal.querySelector('details[open]')) modal.close(false);
      });
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);
  class MuvaziHeaderController extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('[data-muvazi-mobile-header]');
      this.section = this.closest('.section-header');
      if (!this.wrapper || !this.section) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.media = window.matchMedia('(max-width: 989px)');
      this.updateAppearance = () => {
        const enabled = this.wrapper.dataset.muvaziMobileHeader === 'true' && this.media.matches;
        this.wrapper.classList.toggle('muvazi-header--solid', enabled && window.scrollY > 12);
      };
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateAppearance();
        });
      };
      this.measure = () => {
        const height = this.wrapper.getBoundingClientRect().height;
        this.section.style.setProperty('--muvazi-header-height', `${height}px`);
        const announcement = document.querySelector('.announcement-bar-section');
        const announcementHeight = announcement?.getBoundingClientRect().height || 0;
        document.documentElement.style.setProperty('--muvazi-announcement-height', `${announcementHeight}px`);
      };
      this.observeSizes = () => {
        this.observer?.disconnect();
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.measure);
          this.observer.observe(this.wrapper);
          const announcement = document.querySelector('.announcement-bar-section');
          if (announcement) this.observer.observe(announcement);
        }
        this.measure();
      };
      this.onBreakpoint = () => {
        // Search keeps its own focus trap; close it before swapping layouts.
        this.wrapper.querySelectorAll('details-modal').forEach((modal) => {
          if (modal.querySelector('details[open]') && typeof modal.close === 'function') modal.close(false);
        });
        this.updateAppearance();
        this.measure();
      };
      this.media.addEventListener('change', this.onBreakpoint);
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.measure, { passive: true, signal });
      window.addEventListener('pageshow', this.updateAppearance, { signal });
      document.addEventListener('shopify:section:load', this.observeSizes, { signal });
      document.addEventListener('shopify:section:unload', this.observeSizes, { signal });
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.observeSizes, { once: true, signal });
      } else {
        this.observeSizes();
      }
      this.updateAppearance();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.media?.removeEventListener('change', this.onBreakpoint);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  }
  if (!customElements.get('muvazi-header-controller')) {
    customElements.define('muvazi-header-controller', MuvaziHeaderController);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('muvazi-product-dots')) {
  customElements.define(
    'muvazi-product-dots',
    class extends HTMLElement {
      connectedCallback() {
        this.viewer = this.closest('slider-component');
        this.gallery = this.closest('media-gallery');
        this.list = this.viewer?.querySelector('.product__media-list');
        if (!this.list || !this.gallery) return;

        this.mobile = window.matchMedia('(max-width: 749px)');
        this.events = new AbortController();
        this.slides = [];
        this.frame = 0;
        const options = { signal: this.events.signal };
        this.schedule = () => {
          if (this.frame || !this.isConnected) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.refresh();
          });
        };

        this.addEventListener('click', (event) => this.selectSlide(event), options);
        this.viewer.addEventListener('slideChanged', this.schedule, options);
        this.list.addEventListener('scroll', this.schedule, { ...options, passive: true });
        this.mobile.addEventListener('change', this.schedule, options);
        this.mutations = new MutationObserver(this.schedule);
        this.mutations.observe(this.list, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'hidden', 'style', 'data-media-id'],
        });
        this.resize = new ResizeObserver(this.schedule);
        this.resize.observe(this.list);
        this.schedule();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.mutations?.disconnect();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
        this.gallery?.removeAttribute('data-muvazi-dots-ready');
      }

      refresh() {
        if (!this.mobile.matches) {
          this.gallery.removeAttribute('data-muvazi-dots-ready');
          this.hidden = true;
          return;
        }

        const slides = Array.from(this.list.children).filter(
          (slide) => slide.matches('.product__media-item[data-media-id]') && slide.clientWidth > 0
        );
        const changed =
          slides.length !== this.slides.length || slides.some((slide, index) => slide !== this.slides[index]);

        if (changed) {
          const focusedId = this.contains(document.activeElement) ? document.activeElement.dataset.mediaId : null;
          this.slides = slides;
          const buttons = slides.map((slide, index) => {
            const type = slide.dataset.muvaziMediaType;
            const label =
              type === 'model'
                ? this.dataset.modelLabel
                : type === 'video' || type === 'external_video'
                  ? this.dataset.videoLabel
                  : this.dataset.imageLabel;
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'muvazi-product-dot';
            button.dataset.mediaId = slide.dataset.mediaId;
            button.setAttribute('aria-controls', slide.id);
            button.setAttribute('aria-label', label.replace('__index__', String(index + 1)));
            return button;
          });
          this.replaceChildren(...buttons);
          if (focusedId) buttons.find((button) => button.dataset.mediaId === focusedId)?.focus({ preventScroll: true });

          // Dawn keeps a cached list of slides; variant changes can replace or reorder them.
          if (slides.length > 1) this.viewer.resetPages?.();
        }

        this.hidden = slides.length < 2;
        this.gallery.toggleAttribute('data-muvazi-dots-ready', slides.length > 0);
        if (!slides.length) return;

        const viewport = this.list.getBoundingClientRect();
        let current = 0;
        let nearest = Infinity;
        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - viewport.left);
          if (distance < nearest) {
            nearest = distance;
            current = index;
          }
        });
        Array.from(this.children).forEach((button, index) => {
          if (index === current) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });

        // Place the dots inside the current image even when media have different aspect ratios.
        const active = slides[current];
        const image = active.dataset.muvaziMediaType === 'image' ? active.querySelector('.product__media img') : null;
        const media = image || active.querySelector('.product-media-container') || active;
        const bounds = media.getBoundingClientRect();
        const viewerTop = this.viewer.getBoundingClientRect().top;
        // On videos/models keep the bottom controls free.
        const top = image ? bounds.bottom - viewerTop - this.offsetHeight - 8 : bounds.top - viewerTop + 8;
        this.style.top = `${Math.max(0, top)}px`;
        this.dataset.mediaType = active.dataset.muvaziMediaType || 'image';
      }

      selectSlide(event) {
        const button = event.target.closest('button[data-media-id]');
        if (!this.mobile.matches || !button || !this.contains(button)) return;
        const slide = this.slides.find((item) => item.dataset.mediaId === button.dataset.mediaId);
        if (!slide) return;

        const left = this.list.scrollLeft + slide.getBoundingClientRect().left - this.list.getBoundingClientRect().left;
        this.list.scrollTo({
          left,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        });
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muvazi-new-in"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muvazi-new-in-rail')) {
    customElements.define('muvazi-new-in-rail', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        if (!this.cards.length) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.stage = this.querySelector('[data-stage]');
        this.dialog = this.querySelector('[data-dialog]');
        this.content = this.querySelector('[data-dialog-content]');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

        this.index = 0;
        this.position = 0;
        this.animation = 0;

        this.links = this.cards.map(card => card.querySelector('[data-open]'));
        this.planes = this.cards.map(card => card.querySelector('[data-plane]'));

        this.direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.frames = new Set();

        this.labels = JSON.parse(
          this.querySelector('[data-mni-labels]').textContent
        );

        this.groupCache = new Map();
        this.loadSequence = (this.loadSequence || 0) + 1;

        this.classList.add('is-ready');
        this.stage.scrollLeft = 0;

        this.measure();
        this.syncState();

        this.resizeObserver = new ResizeObserver(() => {
          if (this.resizePending) return;
          this.resizePending = true;

          this.nextFrame(() => {
            this.resizePending = false;
            this.measure();
          });
        });

        this.resizeObserver.observe(this.stage);

        this.querySelector('[data-navigation]').hidden = this.cards.length < 2;

        this.addEventListener('click', event => {
          if (Date.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            return;
          }

          const retry = event.target.closest('[data-retry]');

          if (retry && this.lastRequest) {
            return this.loadProduct(...this.lastRequest);
          }

          const color = event.target.closest('[data-combined-url]');

          if (color) {
            if (
              this.adding ||
              color.getAttribute('aria-pressed') === 'true' && !this.fetching
            ) return;

            this.sizeChosen = false;

            return this.loadProduct(color.dataset.combinedUrl, {
              focus: {
                type: 'color',
                value: color.dataset.combinedUrl,
                top: color.getBoundingClientRect().top
              }
            });
          }

          const step = event.target.closest('[data-step]');

          if (step) {
            return this.go(Number(step.dataset.step));
          }

          if (event.target.closest('[data-close]')) {
            return this.dialog.close();
          }

          const galleryStep = event.target.closest('[data-gallery-step]');

          if (galleryStep) {
            return this.moveGallery(Number(galleryStep.dataset.galleryStep));
          }

          const link = event.target.closest('[data-open]');

          if (
            !link ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey
          ) return;

          const index = this.cards.indexOf(link.closest('[data-card]'));

          if (index !== this.index) {
            event.preventDefault();
            this.select(index);
          } else if (typeof this.dialog.showModal === 'function') {
            event.preventDefault();
            this.openDetail(link);
          }
        }, { signal });

        this.addEventListener('change', event => {
          if (event.target.matches('[data-option-id]')) {
            this.changeOption(event.target);
          }
        }, { signal });

        this.addEventListener('submit', event => {
          if (!event.target.matches('[data-buy-form]')) return;

          event.preventDefault();
          this.addToCart(event.target);
        }, { signal });

        this.addEventListener('keydown', event => {
          if (
            this.dialog.open ||
            event.altKey ||
            event.ctrlKey ||
            event.metaKey
          ) return;

          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go((event.key === 'ArrowRight' ? 1 : -1) * this.direction);
          }
        }, { signal });

        this.stage.addEventListener('dragstart', event => {
          event.preventDefault();
        }, { signal });

        this.stage.addEventListener('pointerdown', event => {
          if (
            !event.isPrimary ||
            event.button !== 0 ||
            this.cards.length < 2
          ) return;

          this.stopAnimation();

          this.pointer = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            dx: 0,
            dragging: false,
            position: this.position,
            index: this.index
          };
        }, { signal });

        this.stage.addEventListener('pointermove', event => {
          const pointer = this.pointer;
          if (!pointer || pointer.id !== event.pointerId) return;

          const dx = event.clientX - pointer.x;
          const dy = event.clientY - pointer.y;

          if (!pointer.dragging) {
            if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
              return this.finishDrag(false);
            }

            if (Math.abs(dx) < 10 || Math.abs(dx) <= Math.abs(dy)) return;

            pointer.dragging = true;
            this.stage.setPointerCapture(event.pointerId);
            this.classList.add('is-dragging');
          }

          pointer.dx = dx;
          this.position = pointer.position - dx / this.step * this.direction;

          if (this.cards.length === 2) {
            this.position = Math.max(-.25, Math.min(1.25, this.position));
          }

          if (!this.drawPending) {
            this.drawPending = true;

            this.nextFrame(() => {
              this.drawPending = false;
              this.draw();
            });
          }
        }, { signal });

        this.stage.addEventListener('pointerup', () => {
          this.finishDrag(true);
        }, { signal });

        this.stage.addEventListener('pointercancel', () => {
          this.finishDrag(false);
        }, { signal });

        this.stage.addEventListener('lostpointercapture', event => {
          if (event.target === this.stage) {
            this.finishDrag(false);
          }
        }, { signal });

        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;

          const rect = this.dialog.getBoundingClientRect();

          if (
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom
          ) {
            this.dialog.close();
          }
        }, { signal });

        this.dialog.addEventListener('close', () => {
          this.cleanupDialog(true);
        }, { signal });

        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-card]');

          if (card && this.cards.includes(card)) {
            this.select(this.cards.indexOf(card));
          }
        }, { signal });
      }

      nextFrame(callback) {
        const frame = requestAnimationFrame(() => {
          this.frames.delete(frame);

          if (this.isConnected) {
            callback();
          }
        });

        this.frames.add(frame);
      }

      measure() {
        this.width = this.stage.clientWidth;
        this.cardWidth = parseFloat(getComputedStyle(this.cards[0]).width);

        if (!this.width || !this.cardWidth) return;

        this.step = this.width < 750
          ? Math.max(this.width * .34, this.cardWidth * .64)
          : Math.min(this.cardWidth * .95, this.width * .225);

        this.curve = Math.max(24, Math.min(48, this.width * .04));

        const rail = this.querySelector('[data-rail]');
        rail.setAttribute('viewBox', `0 0 ${this.width} 130`);

        rail.querySelectorAll('[data-rail-path]').forEach(path => {
          path.setAttribute(
            'd',
            `M0 18 Q${this.width / 2} ${18 + this.curve * 2} ${this.width} 18`
          );
        });

        this.draw();
      }

      go(step) {
        this.select(this.index + step);
      }

      select(index) {
        const focused = this.cards.some(card => {
          return card.contains(document.activeElement);
        });

        const count = this.cards.length;
        this.index = ((index % count) + count) % count;

        this.syncState();
        this.animateTo(this.index);

        if (focused) {
          this.links[this.index].focus({ preventScroll: true });
        }
      }

      syncState() {
        this.cards.forEach((card, index) => {
          const active = index === this.index;

          card.classList.toggle('is-active', active);
          card.setAttribute('aria-hidden', String(!active));

          this.links[index].tabIndex = active ? 0 : -1;

          if (active) {
            this.links[index].setAttribute('aria-current', 'true');
          } else {
            this.links[index].removeAttribute('aria-current');
          }
        });

        this.querySelector('[data-count]').textContent =
          `${String(this.index + 1).padStart(2, '0')} / ${String(this.cards.length).padStart(2, '0')}`;
      }

      stopAnimation() {
        cancelAnimationFrame(this.animation);
        this.animation = 0;
        this.classList.remove('is-moving');
      }

      animateTo(index) {
        this.stopAnimation();

        const count = this.cards.length;
        let target = index;

        if (count > 2) {
          target += Math.round((this.position - index) / count) * count;
        }

        if (
          this.reducedMotion.matches ||
          Math.abs(target - this.position) < .001
        ) {
          this.position = index;
          this.draw();
          return;
        }

        const from = this.position;
        const start = performance.now();

        this.classList.add('is-moving');

        const tick = time => {
          if (!this.isConnected) return;

          const progress = this.reducedMotion.matches
            ? 1
            : Math.min(1, (time - start) / 680);

          this.position =
            from + (target - from) * (1 - Math.pow(1 - progress, 3));

          this.draw();

          if (progress < 1) {
            this.animation = requestAnimationFrame(tick);
          } else {
            this.position = this.index;
            this.draw();
            this.animation = 0;
            this.classList.remove('is-moving');
          }
        };

        this.animation = requestAnimationFrame(tick);
      }

      draw() {
        if (!this.width) return;

        const count = this.cards.length;

        this.cards.forEach((card, index) => {
          let distance = index - this.position;

          if (count > 2) {
            distance =
              ((distance + count / 2) % count + count) % count - count / 2;
          }

          const depth = Math.abs(distance);
          const edge = Math.min(3, count / 2);

          const opacity = count > 2
            ? Math.max(0, Math.min(1, (edge - depth) * 2))
            : 1;

          const x =
            this.width / 2 + distance * this.step * this.direction;

          const normalizedX =
            (x - this.width / 2) / (this.width / 2);

          const y =
            18 + this.curve * (1 - normalizedX * normalizedX);

          const scale = 1 - Math.min(depth, 2) * .08;
          const turn = -82 * Math.tanh(distance * 2) * this.direction;

          card.style.transform =
            `translate3d(${x - this.cardWidth / 2}px, ${y}px, 0) scale(${scale})`;

          card.style.opacity = opacity;
          card.style.visibility = opacity > .001 ? 'visible' : 'hidden';
          card.style.pointerEvents = opacity > .1 ? 'auto' : 'none';
          card.style.zIndex = Math.max(1, 100 - Math.round(depth * 10));

          this.planes[index].style.transform = `rotateY(${turn}deg)`;
        });
      }

      finishDrag(commit) {
        const pointer = this.pointer;
        if (!pointer) return;

        this.pointer = null;

        if (this.stage.hasPointerCapture(pointer.id)) {
          this.stage.releasePointerCapture(pointer.id);
        }

        this.classList.remove('is-dragging');

        if (!pointer.dragging) {
          return this.animateTo(this.index);
        }

        this.suppressClickUntil = Date.now() + 300;
        let target = this.index;

        if (commit) {
          const movement = this.position - pointer.position;
          target = Math.round(this.position);

          if (Math.abs(movement) < .5 && Math.abs(pointer.dx) > 35) {
            target = pointer.index + Math.sign(movement);
          }
        }

        this.select(target);
      }

      openDetail(opener) {
        this.stopAnimation();
        this.position = this.index;
        this.draw();

        this.opener = opener;
        this.sizeChosen = false;

        this.content.replaceChildren(
          this.cards[this.index]
            .querySelector('[data-detail]')
            .content.cloneNode(true)
        );

        this.content.querySelector('[data-dialog-title]').id =
          this.dialog.getAttribute('aria-labelledby');

        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;

        this.dialog.showModal();
        this.content.scrollTop = 0;

        this.setupGallery();
        this.loadProduct(opener.href);
      }

      productURL(value) {
        const url = new URL(value, location.origin);

        if (
          url.origin !== location.origin ||
          !url.pathname.includes('/products/')
        ) {
          throw new Error('Invalid product URL');
        }

        const root = this.dataset.rootUrl || '/';

        if (url.pathname.startsWith('/products/') && root !== '/') {
          url.pathname = root.replace(/\/$/, '') + url.pathname;
        }

        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');

        return url;
      }

      groupKey(value) {
        return this.productURL(value).pathname.split('/products/')[1];
      }

      async combinedGroups(url, signal) {
        const key = this.groupKey(url);

        if (this.groupCache.has(key)) {
          return this.groupCache.get(key);
        }

        let source = Array.from(
          document.querySelectorAll(
            'script[data-rubik-swatch-product-handle]'
          )
        ).find(node => {
          return node.dataset.rubikSwatchProductHandle === key;
        });

        if (!source) {
          const pageURL = this.productURL(url);
          pageURL.search = '';

          const response = await fetch(pageURL, {
            signal,
            credentials: 'same-origin'
          });

          if (!response.ok) {
            throw new Error('Product data unavailable');
          }

          const page = new DOMParser().parseFromString(
            await response.text(),
            'text/html'
          );

          source = Array.from(
            page.querySelectorAll(
              'script[data-rubik-swatch-product-handle]'
            )
          ).find(node => {
            return node.dataset.rubikSwatchProductHandle === key;
          });
        }

        const groups = source
          ? JSON.parse(source.textContent).groups || []
          : [];

        this.groupCache.set(key, groups);

        if (groups.length === 1) {
          groups[0].swatches?.forEach(swatch => {
            try {
              this.groupCache.set(
                this.groupKey(swatch.productUrl),
                groups
              );
            } catch {}
          });
        }

        return groups;
      }

      async loadProduct(rawURL, options = {}) {
        this.loadController?.abort();

        const controller = new AbortController();
        this.loadController = controller;

        const request = ++this.loadSequence;
        const timeout = setTimeout(() => controller.abort(), 15000);

        this.lastRequest = [rawURL, options];
        this.fetching = true;
        this.loadFailed = false;
        this.productChanging = options.mode !== 'option';

        this.dialog.classList.add('is-loading');
        this.content.setAttribute('aria-busy', 'true');

        this.content.querySelectorAll('[data-option-name]').forEach(field => {
          field.disabled = this.productChanging;
        });

        this.content.querySelector('[data-load-error]')?.remove();
        this.updateBuy();

        try {
          const url = this.productURL(rawURL);

          if (options.ids?.length) {
            url.searchParams.delete('variant');
            url.searchParams.set('option_values', options.ids.join(','));
          }

          const renderURL = new URL(url);

          renderURL.searchParams.set(
            'section_id',
            this.dataset.renderSection
          );

          const [response, groups] = await Promise.all([
            fetch(renderURL, {
              signal: controller.signal,
              credentials: 'same-origin'
            }),
            options.mode === 'option'
              ? Promise.resolve(this.groups || [])
              : this.combinedGroups(url, controller.signal)
          ]);

          if (!response.ok) {
            throw new Error('Product section unavailable');
          }

          const html = new DOMParser().parseFromString(
            await response.text(),
            'text/html'
          );

          const payload = html.querySelector('[data-mni-payload]');

          if (!payload) {
            throw new Error('Product section missing');
          }

          if (request !== this.loadSequence || !this.dialog.open) return;

          const existing = this.content.querySelector('[data-mni-payload]');

          const keepGallery =
            options.mode === 'option' &&
            existing?.dataset.productId === payload.dataset.productId;

          if (keepGallery) {
            this.content.querySelector('[data-purchase]').replaceWith(
              payload.querySelector('[data-purchase]')
            );
          } else {
            this.content.replaceChildren(payload);
          }

          this.productUrl = this.productURL(payload.dataset.productUrl).href;
          this.productId = payload.dataset.productId;
          this.groups = groups;

          this.hydratePurchase();

          if (!keepGallery) {
            this.setupGallery();
          }

          this.fetching = false;
          this.productChanging = false;
          this.updateBuy();

          if (options.focus) {
            const selector = options.focus.type === 'option'
              ? '[data-option-id]'
              : '[data-combined-url]';

            const key = options.focus.type === 'option'
              ? 'optionId'
              : 'combinedUrl';

            const target = Array.from(
              this.content.querySelectorAll(selector)
            ).find(node => {
              return node.dataset[key] === options.focus.value;
            });

            if (target) {
              target.focus({ preventScroll: true });

              if (Number.isFinite(options.focus.top)) {
                this.content.scrollTop +=
                  target.getBoundingClientRect().top - options.focus.top;
              }
            }
          }

          if (this.variantState.imageId && options.mode === 'option') {
            const slides = Array.from(this.gallery.children);

            const imageIndex = slides.findIndex(slide => {
              return slide.dataset.imageId === String(this.variantState.imageId);
            });

            if (imageIndex >= 0) {
              this.gallery.scrollTo({
                left: imageIndex * this.gallery.clientWidth,
                behavior: 'instant'
              });
            }
          }
        } catch (error) {
          if (request !== this.loadSequence || !this.dialog.open) return;

          this.loadFailed = true;

          const info = this.content.querySelector('.mni__detail-info');
          info.querySelector('[data-loading-status]')?.remove();

          const box = document.createElement('div');
          box.dataset.loadError = '';
          box.className = 'mni__error';
          box.setAttribute('role', 'alert');

          const message = document.createElement('p');
          message.textContent = this.labels.loadError;

          const retry = document.createElement('button');
          retry.type = 'button';
          retry.dataset.retry = '';
          retry.className = 'mni__retry';
          retry.textContent = this.labels.retry;

          box.append(message, retry);
          info.append(box);
        } finally {
          clearTimeout(timeout);

          if (request === this.loadSequence) {
            this.fetching = false;
            this.productChanging = false;

            this.dialog.classList.remove('is-loading');
            this.content.removeAttribute('aria-busy');

            this.content.querySelectorAll('[data-option-name]').forEach(field => {
              field.disabled = false;
            });

            this.updateBuy();
          }
        }
      }

      hydratePurchase() {
        const info = this.content.querySelector('[data-purchase]');

        info.querySelector('[data-dialog-title]').id =
          this.dialog.getAttribute('aria-labelledby');

        this.variantState = JSON.parse(
          info.querySelector('[data-variant-state]').textContent
        );

        info.querySelectorAll('[data-option-id]').forEach(input => {
          input.dataset.serverSelected = String(input.checked);

          if (input.closest('[data-size-option]') && !this.sizeChosen) {
            input.checked = false;
          }
        });

        info.querySelector('[data-services]').replaceChildren(
          this.querySelector('[data-service-template]').content.cloneNode(true)
        );

        info.querySelectorAll('[data-label]').forEach(node => {
          node.textContent = this.labels[node.dataset.label];
        });

        const fullLink = info.querySelector('[data-full-product]');

        fullLink.replaceChildren(
          document.createTextNode(this.labels.product + ' ↗')
        );

        this.renderCombined(info);
      }

      optionName(value) {
        const name = String(value).trim().toLowerCase();

        return ['farbe', 'color', 'colour'].includes(name)
          ? 'color'
          : name;
      }

      renderCombined(info) {
        const container = info.querySelector('[data-combined-options]');
        container.replaceChildren();

        (this.groups || [])
          .filter(group => {
            return group.settings?.is_active !== false && group.swatches?.length;
          })
          .forEach(group => {
            const field = document.createElement('fieldset');
            field.className = 'mni__option';

            const legend = document.createElement('legend');

            const current = group.swatches.find(swatch => {
              return String(swatch.productId) === this.productId;
            });

            legend.textContent =
              group.optionName + (current ? ' · ' + current.optionValue : '');

            const choices = document.createElement('div');
            choices.className = 'mni__choices';

            group.swatches.forEach(swatch => {
              let url;

              try {
                url = this.productURL(swatch.productUrl);
              } catch {
                return;
              }

              const selected = String(swatch.productId) === this.productId;
              const button = document.createElement('button');

              button.type = 'button';
              button.className = 'mni__color';
              button.dataset.combinedUrl = url.href;
              button.setAttribute('aria-pressed', String(selected));

              if (swatch.productAvailable === false) {
                button.classList.add('is-unavailable');
              }

              if (swatch.color && CSS.supports('color', swatch.color)) {
                const dot = document.createElement('span');

                dot.className = 'mni__color-dot';
                dot.setAttribute('aria-hidden', 'true');
                dot.style.backgroundColor = swatch.color;

                if (
                  swatch.secondaryColor &&
                  CSS.supports('color', swatch.secondaryColor)
                ) {
                  dot.style.backgroundImage =
                    `linear-gradient(135deg, ${swatch.color} 50%, ${swatch.secondaryColor} 50%)`;
                }

                button.append(dot);
              }

              button.append(document.createTextNode(swatch.optionValue));
              choices.append(button);
            });

            field.append(legend, choices);
            container.append(field);

            info.querySelectorAll('[data-option-name]').forEach(native => {
              if (
                this.optionName(native.dataset.optionName) ===
                this.optionName(group.optionName)
              ) {
                native.hidden = true;
              }
            });
          });
      }

      changeOption(input) {
        if (this.productChanging || this.adding) return;

        if (input.closest('[data-size-option]')) {
          this.sizeChosen = true;
        }

        const url = this.productURL(
          input.dataset.productUrl || this.productUrl
        );

        const changedProduct =
          url.pathname !== this.productURL(this.productUrl).pathname;

        const ids = Array.from(
          this.content.querySelectorAll('[data-option-name]')
        ).map(field => {
          return (
            field.querySelector('input:checked') ||
            field.querySelector('[data-server-selected="true"]')
          )?.dataset.optionId;
        }).filter(Boolean);

        if (changedProduct) {
          this.sizeChosen = false;
        }

        this.loadProduct(url.href, {
          mode: changedProduct ? 'product' : 'option',
          ids,
          focus: {
            type: 'option',
            value: input.dataset.optionId,
            top: input.getBoundingClientRect().top
          }
        });
      }

      updateBuy() {
        const button = this.content?.querySelector('[data-buy]');
        if (!button) return;

        this.content.querySelectorAll('[data-option-name]').forEach(field => {
          field.disabled = !!(this.productChanging || this.adding);
        });

        this.content.querySelectorAll('[data-combined-url]').forEach(color => {
          color.disabled = !!this.adding;
        });

        const sizeMissing =
          this.content.querySelector('[data-size-option]') && !this.sizeChosen;

        const state = this.variantState || {};

        button.disabled = !!(
          this.fetching ||
          this.loadFailed ||
          this.adding ||
          sizeMissing ||
          !state.id ||
          !state.available ||
          state.requiresPlan
        );

        button.setAttribute('aria-busy', String(!!this.adding));

        button.querySelector('.mni__spinner').hidden = !this.adding;

        button.querySelector('[data-buy-text]').textContent =
          this.adding
            ? this.dataset.loading
            : !state.id
              ? this.dataset.unavailable
              : !state.available
                ? this.dataset.soldOut
                : this.labels.add;

        this.content.querySelector('[data-purchase-message]').textContent =
          this.fetching
            ? this.dataset.loading
            : sizeMissing
              ? this.labels.chooseSize
              : '';
      }

async addToCart(form) {
  const button = form.querySelector('[data-buy]');
  if (this.adding || button.disabled) return;

  const errorBox = form.querySelector('[data-purchase-error]');
  errorBox.hidden = true;

  this.adding = true;
  this.updateBuy();

  const data = new FormData(form);
  const sectionIds = ['cart-icon-bubble'];

  if (document.querySelector('cart-drawer')) {
    sectionIds.push('cart-drawer');
  }

  data.set('sections', sectionIds.join(','));
  data.set('sections_url', location.pathname);

  let result;
  let rejectedMessage = '';

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);

  try {
    const response = await fetch(
      (this.dataset.rootUrl || '/') + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        signal: controller.signal,
        body: data
      }
    );

    result = await response.json();

    if (!response.ok || result.status) {
      rejectedMessage =
        typeof result.description === 'string'
          ? result.description
          : this.labels.cartError;

      throw new Error('Cart rejected');
    }
  } catch (error) {
    errorBox.textContent = rejectedMessage || this.labels.cartError;
    errorBox.hidden = false;

    this.adding = false;
    this.updateBuy();
    return;
  } finally {
    clearTimeout(timeout);
  }

  this.adding = false;
  this.updateBuy();

  if (this.dialog.open && this.content.contains(form)) {
    form.querySelector('[data-purchase-message]').textContent =
      this.labels.added || 'Zum Warenkorb hinzugefügt.';
  }

  try {
    const sections = result.sections || {};
    const parser = new DOMParser();
    const bubble = document.getElementById('cart-icon-bubble');

    if (bubble && typeof sections['cart-icon-bubble'] === 'string') {
      const rendered = parser.parseFromString(
        sections['cart-icon-bubble'],
        'text/html'
      );

      const content = rendered.querySelector('.shopify-section');

      if (content) {
        bubble.replaceChildren(...content.childNodes);
      }
    }

    const drawer = document.querySelector('cart-drawer');

    if (drawer && typeof sections['cart-drawer'] === 'string') {
      const rendered = parser.parseFromString(
        sections['cart-drawer'],
        'text/html'
      );

      const newDrawer = rendered.querySelector('cart-drawer');
      const currentInner = drawer.querySelector('.drawer__inner');
      const nextInner = newDrawer?.querySelector('.drawer__inner');

      if (currentInner && nextInner) {
        currentInner.replaceWith(nextInner);

        drawer.classList.toggle(
          'is-empty',
          newDrawer.classList.contains('is-empty')
        );
      }
    }
  } catch {}

  if (
    typeof publish === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    try {
      Promise.resolve(
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'muvazi-new-in',
          productVariantId: data.get('id'),
          cartData: result
        })
      ).catch(() => {});
    } catch {}
  }
}
      setupGallery() {
        this.galleryController?.abort();
        this.gallery = this.content.querySelector('[data-gallery]');

        if (!this.gallery) return;

        this.galleryController = new AbortController();

        this.gallery.addEventListener('scroll', () => {
          if (this.galleryTick) return;

          this.galleryTick = true;

          this.nextFrame(() => {
            this.galleryTick = false;
            this.updateGallery();
          });
        }, {
          passive: true,
          signal: this.galleryController.signal
        });

        this.nextFrame(() => this.updateGallery());
      }

      updateGallery() {
        if (!this.gallery) return;

        const count = this.gallery.children.length;

        const current = Math.max(
          0,
          Math.min(
            count - 1,
            Math.round(
              this.gallery.scrollLeft /
              Math.max(1, this.gallery.clientWidth)
            )
          )
        );

        const counter = this.content.querySelector('[data-gallery-count]');

        if (counter) {
          counter.textContent = `${current + 1} / ${count}`;
        }

        this.content.querySelectorAll('[data-gallery-step]').forEach(button => {
          button.disabled = Number(button.dataset.galleryStep) < 0
            ? current === 0
            : current === count - 1;
        });
      }

      moveGallery(step) {
        if (!this.gallery) return;

        this.gallery.scrollBy({
          left: this.gallery.clientWidth * step,
          behavior: this.reducedMotion.matches ? 'instant' : 'smooth'
        });
      }

      cleanupDialog(restoreFocus) {
        this.loadController?.abort();
        this.loadSequence = (this.loadSequence || 0) + 1;

        this.fetching = false;
        this.loadFailed = false;

        this.dialog?.classList.remove('is-loading');
        this.content?.removeAttribute('aria-busy');

        this.galleryController?.abort();
        this.galleryController = null;
        this.gallery = null;
        this.galleryTick = false;

        if (this.scrollLocked) {
          document.documentElement.style.overflow = this.previousOverflow;
        }

        this.scrollLocked = false;
        this.content?.replaceChildren();

        if (restoreFocus && this.opener?.isConnected) {
          this.opener.focus({ preventScroll: true });
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;

        this.stopAnimation();
        this.pointer = null;

        this.classList.remove('is-dragging');

        this.resizeObserver?.disconnect();
        this.resizePending = false;
        this.drawPending = false;

        this.frames?.forEach(frame => cancelAnimationFrame(frame));

        if (this.dialog?.open) {
          this.dialog.close();
        }

        this.cleanupDialog(false);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
